import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from 'lodash';
import Checkbox from '../../../../components/form-elements/Checkbox';
import { renderPassengerFullName, renderSeatNumber } from '../../../../../helpers/passenger-helper';
import { STATUS_TITLES, APPROVED, REFUNDING, REFUSED } from '../../../DashboardOrders/Order/Passenger/helper';
const ReturnTicket = ({
  id,
  seatNumber,
  status,
  passenger,
  index = 0,
  isMulti = false,
  isLuggage = false,
  onTicketChange,
  isChecked
}) => {
  const isRefundCompleted = [APPROVED, REFUSED].includes(status);
  const isRefundRequested = status === REFUNDING;
  const isDeactivated = isRefundCompleted || isRefundRequested;
  const renderTicketTitle = () => {
    if (isLuggage) {
      return I18n.t(`pages.account.order.luggage${isMulti ? '_many' : ''}`, {
        fio: renderPassengerFullName(passenger),
        count: index + 1
      });
    }
    return renderPassengerFullName(passenger);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('order-return__passenger flex align-center justify-between', {
      'order-return__passenger--deactivated': isDeactivated
    }),
    onClick: isDeactivated ? noop : e => {
      e.preventDefault();
      e.stopPropagation();
      onTicketChange(id);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex align-start"
  }, !isDeactivated && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
    isChecked: isChecked
  })), /*#__PURE__*/React.createElement("div", {
    className: "order-return__passenger-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "order-return__passenger-name"
  }, renderTicketTitle()), /*#__PURE__*/React.createElement("div", {
    className: "order-return__passenger-ticket-details flex"
  }, /*#__PURE__*/React.createElement("span", null, I18n.t('components.Order.ticket_number', {
    number: id
  })), /*#__PURE__*/React.createElement("span", null, renderSeatNumber(seatNumber))))), /*#__PURE__*/React.createElement("div", {
    className: classNames('order-return__passenger__ticket-status', {
      'order-return__passenger__ticket-status--completed': isRefundCompleted,
      'order-return__passenger__ticket-status--requested-refund': isRefundRequested
    })
  }, STATUS_TITLES[status]));
};
ReturnTicket.propTypes = {
  id: PropTypes.string.isRequired,
  passenger: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    secondName: PropTypes.string
  }),
  seatNumber: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  index: PropTypes.number,
  isMulti: PropTypes.bool,
  isLuggage: PropTypes.bool,
  onTicketChange: PropTypes.func,
  isChecked: PropTypes.bool
};
export default ReturnTicket;